import { combineReducers } from 'redux';

import allLeads from 'app/shared/reducers/lead/allLeads';
import lead from 'app/shared/reducers/lead/lead';

const rootLeadReducer = combineReducers({
    allLeads,
    lead,
});

export default rootLeadReducer;
